import "./NameComponent.css";
import { useSpring, animated } from "@react-spring/web";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import GithubSymbol from "./NameComponentSymbols/githubSymbol";
import EmailSymbol from "./NameComponentSymbols/emailSymbol";
import LinkedinSymbol from "./NameComponentSymbols/linkedinSymbol";

import "react-step-progress-bar/styles.css";
import TDComponent from "./3dComponents/3dComponents.js";

import Chart from "./ChartComponent/chartComp";

import Game1 from "../gifs/Game1.gif";
import Game2 from "../gifs/Game2.gif";
import Game3 from "../gifs/Game3.gif";
import Proj1 from "../gifs/Proj1.gif";
import Site1 from "../gifs/Site1.gif";
import Site2 from "../gifs/Site2.gif";

import ProjectComponent from "./ProjectComponents/ProjectComponent.js";

import SecretComponent from "./EggComponent/SecretComponent";

export default function NameComponent() {
  const fadeStyles = useSpring({
    from: {
      opacity: 0,
      x: -800,
    },
    to: {
      opacity: 1,
      x: 0,
    },
    config: { tension: 220, friction: 150 },
  });

  const linkStyles = useSpring({
    from: {
      opacity: 0,
      x: -1400,
    },
    to: {
      opacity: 1,
      x: 0,
    },
    config: { tension: 220, friction: 150 },
  });

  function reveal() {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 150;
      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      }
    }
  }

  window.addEventListener("scroll", reveal);

  return (
    <div id="top">
      <TDComponent></TDComponent>

      <main>
        <div id="shown">
          <Container className="container-fluid">
            <div id="introduction-section">
              <Row>
                <Col md={8}>
                  <animated.div style={fadeStyles}>
                    <center>
                      <h1 className="display-1"> Nicolas Amatuzio </h1>
                    </center>
                    <center>
                      <h3> Software Developer & Student </h3>
                    </center>
                  </animated.div>
                </Col>
                <Col
                  md={1}
                  className="d-flex align-items-center justify-content-center"
                >
                  <center>
                    <animated.div style={linkStyles}>
                      <GithubSymbol></GithubSymbol>
                    </animated.div>
                  </center>
                </Col>
                <Col
                  md={2}
                  className="d-flex align-items-center justify-content-center"
                >
                  <center>
                    <animated.div style={linkStyles}>
                      <EmailSymbol></EmailSymbol>
                    </animated.div>
                  </center>
                </Col>
                <Col
                  md={1}
                  className="d-flex align-items-center justify-content-center"
                >
                  <animated.div style={linkStyles}>
                    <LinkedinSymbol></LinkedinSymbol>
                  </animated.div>
                </Col>
              </Row>
              <Row>
                <Col md={12}></Col>
              </Row>
              <br></br>
              <Row>
                <Col lg={8}>
                  <animated.div style={fadeStyles}>
                    <p className="intro-text">
                      &#128400; Hey hey people, I'm Nicolas Amatuzio &#128400;
                      <br></br>
                      &#127809; I'm a software development student at Seneca
                      College in Toronto, Ontario &#127809;
                      <br></br>
                      ✏️ I have a passion for learning and creating new things
                      ✏️
                      <br></br>
                      &#128521; I'm currently looking for an internship for the
                      Winter 2023 semester &#128521;
                    </p>
                    <p className="intro-text">
                      My prevalent interests include web development, game
                      development, and information security.
                      <br></br>I love meeting and working with new people, and
                      I'm always looking for new opportunities to learn and
                      grow.
                      <br></br>
                      🖥️ Two of my favourite languages are C++ and Java ☕.
                      <br></br>
                      🐍 I'm currently working on learning Python! 🐍
                      <br></br>
                      🎉 If you have any questions about projects, experience,
                      or just want to talk, 🎊
                      <br></br>
                      🎉feel free to reach out to me! 🎊
                    </p>
                  </animated.div>
                </Col>
                <Col lg={4}>
                  <Chart></Chart>
                </Col>
              </Row>
            </div>
            <div id="personal-projects">
              <Row>
                <Col md={8} className="display-6">
                  Personal Projects
                </Col>
                <Col md={2}></Col>
                <Col md={2}></Col>
              </Row>

              <Row>
                <Col lg={4}>
                  <section className="personal-project-item reveal">
                    {ProjectComponent(
                      "Splat",
                      "A game that was developed for a game jam that I participated in. A beloved painter was sucked into a blank canvas and must escape by painting his way through an unpainted world utilizing a paint gun which makes use of three common types of paint; acrylic, watercolour, and oil paint. Each paint has different properties. The game is fully functioning and playable. Developed in Game Maker Studio 2.",
                      Game2
                    )}
                  </section>
                </Col>
                <Col lg={4}>
                  <section className="personal-project-item reveal">
                    {ProjectComponent(
                      "Travel Companion",
                      "A website that was developed by a team of 4 for a major school project. The website was designed to be a platform for those who love to travel to different places. Users can make accounts, post their travel plans for others to see and join travel plans that others have posted. The whole project was created using the MERN stack. The backend was developed with JavaScript, more specifically express.js, with the help of MongoDB for our choice of database. The front end utilized React and Bootstrap for styling and functionality.",
                      Site1
                    )}
                  </section>
                </Col>
                <Col lg={4}>
                  <section className="personal-project-item reveal ">
                    {ProjectComponent(
                      "Super Stickman",
                      "One of my earliest completed projects in Game Maker Studio 2. A simple action platformer where you control a stickman in an alien invasion of ruby golems. Rough around the edges, but a lot was implemented such as parallax backgrounds, tilesets, moveable cameras, and room states. The game is fully functioning and playable. Developed in Game Maker Studio 2.",
                      Game3
                    )}
                  </section>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <section className="personal-project-item reveal">
                    {ProjectComponent(
                      "OpenGL Game Engine",
                      "A fully functioning game engine developed entirely in OpenGL and C++. The engine was created to be used in a game engine development course. The engine is primarily used for creating 3D shooter games. The engine was created using the OpenGL API and C++.",
                      Proj1
                    )}
                  </section>
                </Col>
                <Col lg={4}>
                  <section className="personal-project-item reveal">
                    {ProjectComponent(
                      "Roguelike",
                      "A simplistic project that I made to learn more about how to efficiently create a game. Tested multiple features such as physics, collisions, movement, and items the player can interact with to change certain attributes. The game is still in development and is not playable yet. Developed in Game Maker Studio 2.",
                      Game1
                    )}
                  </section>
                </Col>
                <Col lg={4}>
                  <section className="personal-project-item reveal">
                    {ProjectComponent(
                      "Blackjack Android App",
                      "A mobile app that was developed by a team of 3 for a school project. The application is a simple blackjack game where users are able to create an account and play against an AI dealer. The application was created using Java and AWS amplify for user accounts. Developed in Android Studio.",
                      Site2
                    )}
                  </section>
                </Col>
              </Row>
            </div>
            <div className="personal-website-project">
              <Row>
                <Col md={8} className="display-6">
                  The development of this website
                </Col>
              </Row>
              <Row>
                <section className="personal-project-item reveal">
                  <Col lg={12}>
                    <p className="personal-website-project-text">
                      If you haven't guessed already, this is a personal
                      portfolio project that I decided to build from the ground
                      up as a fun and interactive way to further my skills in
                      web development. My original plan for the site didn't even
                      see the use of 3js in the planning stages.
                    </p>

                    <p className="personal-website-project-text">
                      A lot of inspiration for my initial plan came from many
                      gorgeous portfolio websites that I found such as{" "}
                      <a href="https://jacekjeznach.com/">
                        Jack Jeznach's portfolio website
                      </a>
                      . I thought it was incredible how fast, interactive, and
                      neatly organized the site was. Which I found out was what
                      I love most about portfolio websites. I then stumbled upon{" "}
                      <a href="https://bruno-simon.com/">
                        {" "}
                        Bruno Simon's portfolio website{" "}
                      </a>{" "}
                      which was probably one of the coolest websites I had seen.
                      Although, it wasn't until I saw a few{" "}
                      <a href="https://threejs.org/">
                        example projects using 3js from the main site{" "}
                      </a>{" "}
                      and a beautifully simple video from{" "}
                      <a href="https://www.youtube.com/watch?v=Q7AOvWpIVHU">
                        Fireship on youtube
                      </a>{" "}
                      that I decided that 3js would be the main component of my
                      website.
                    </p>
                    <p className="personal-website-project-text">
                      I had a slightly easier time using 3js since I had
                      previously worked with OpenGL and GLSL. Although I still
                      ran into my fair share of issues. The biggest issue I
                      faced when designing the website was certainly idea bloat.
                      My mind would often run wild with ideas I thought would be
                      awesome for a personal website but would take far too long
                      for me to properly implement. It got to the point where I
                      had to create a timeline for myself in order to not go off
                      the beaten path so that I would actually be able to
                      release something I'm proud of this year. I personally
                      used <a href="https://trello.com/en"> Trello</a>, A very
                      nice website that I've known about and used for years to
                      keep on track for projects.{" "}
                    </p>

                    <p className="personal-website-project-text">
                      I used 4 libraries in conjunction with React.js, Node.js,
                      and 3js those being: <br></br>
                      Chart.js (for the chart in the intro), Tilt.js (for the
                      project cards), React-Spring (for the load anims),
                      Bootstrap (for styling components).
                    </p>
                  </Col>
                </section>
              </Row>
            </div>
          </Container>
        </div>
        <SecretComponent></SecretComponent>
      </main>
    </div>
  );
}
